.root {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.mainWrap {
  position: relative;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.mainStage {
  position: relative;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  border-radius: 2px;
  overflow: hidden;
}

.mainViewport {
  position: relative;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.mainSwiper {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;

  :global(.swiper-wrapper) {
    min-width: 0;
  }

  :global(.swiper-slide) {
    height: auto;
    display: flex;
    align-items: stretch;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
  }
}

.mainSlide {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}

.mainStageTap {
  cursor: zoom-in;
}

.mainImage,
.mainVideo {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  display: block;
  vertical-align: top;
}

.mainVideo {
  background: #111;
}

.videoBox {
  position: relative;
  width: 100%;
}

.videoLoading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.25);
  pointer-events: none;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: pgSpin 0.75s linear infinite;
}

@keyframes pgSpin {
  to {
    transform: rotate(360deg);
  }
}

.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.navBtn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  border: 0;
  padding: 0;
  width: clamp(40px, 8vw, 56px);
  height: clamp(40px, 8vw, 56px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  cursor: pointer;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.2));

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    pointer-events: none;
  }

  &:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 2px;
  }
}

.navPrev {
  left: clamp(8px, 2vw, 16px);
}

.navNext {
  right: clamp(8px, 2vw, 16px);
}

.thumbs {
  margin-top: clamp(12px, 2.2vw, 24px);
  display: flex;
  gap: clamp(8px, 1.2vw, 12px);
  width: 100%;
  justify-content: flex-start;
}

.thumbsMany {
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  padding-bottom: 2px;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(22, 0, 4, 0.2);
    border-radius: 4px;
  }
}

.thumbsFew {
  overflow-x: visible;
}

.thumb {
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  min-height: 44px;
  box-sizing: border-box;
  /* 与主图同宽容器下，单枚缩略图宽度 = 主图宽度的 1/5 */
  flex: 0 0 20%;
  max-width: 20%;
}

.thumbInner {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 2px;
  overflow: hidden;
  border: 2px solid transparent;
  transition: border-color 0.15s ease;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.thumbActive .thumbInner {
  border-color: rgba(22, 0, 4, 1);
}

.playOverlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.playSvg {
  width: clamp(28px, 5vw, 40px);
  height: clamp(28px, 5vw, 40px);
  filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.15));
}

.mobileFsEnter {
  display: none;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 3;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: rgba(22, 0, 4, 0.85);
  font-size: 18px;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);

  &:focus-visible {
    outline: 2px solid rgba(22, 0, 4, 0.6);
    outline-offset: 2px;
  }
}

@media (max-width: 767px) {
  .mainStageTap.mainStageVideo .mobileFsEnter {
    display: flex;
  }
}

.fsRoot {
  position: fixed;
  inset: 0;
  z-index: 10050;
  width: 100%;
  height: 100dvh;
  max-height: 100dvh;
  background: #000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}

.fsChrome {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: max(12px, env(safe-area-inset-top));
  padding-right: max(16px, env(safe-area-inset-right));
  padding-bottom: 10px;
  padding-left: max(12px, env(safe-area-inset-left));
  z-index: 10;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
}

.fsBack {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 20px;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 2px;
  }
}

.fsCounter {
  margin-left: auto;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  font-size: 14px;
  font-family: PingFang SC-Regular, system-ui, sans-serif;
  letter-spacing: 0.02em;
}

.fsViewport {
  flex: 1;
  min-height: 0;
  width: 100%;
  position: relative;
  overflow: hidden;
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing: border-box;
}

.fsSwiper {
  width: 100%;
  height: 100%;
  max-height: 100%;

  :global(.swiper) {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  :global(.swiper-wrapper) {
    height: 100%;
  }

  :global(.swiper-slide) {
    height: 100%;
    max-height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  :global(.swiper-zoom-container) {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
}

.fsSlide {
  height: 100%;
  max-height: 100%;
}

.fsImage {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  user-select: none;
  -webkit-user-drag: none;
}

.fsVideoWrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 12px 24px;
  box-sizing: border-box;
}

.fsVideo {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  background: #111;
}

@media (max-width: 767px) {
  .navBtn {
    width: clamp(36px, 10vw, 48px);
    height: clamp(36px, 10vw, 48px);
  }
}
